import { CountryState, FetchState } from "@/shared/types";
import { getCountries as fetchCountries } from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

export const initialState: CountryState = {
  fetchState: FetchState.Uninitialized,
  countries: []
};

export const useCountryStore = defineStore("country", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    getCountries () {
      if (this.fetchState === FetchState.Loaded) {
        return;
      }

      this.fetchState = FetchState.Loading;
      this.countries = [];

      fetchCountries()
        .then(response => {
          this.countries = response.data.countries;
          this.fetchState = FetchState.Loaded;
        })
        .catch(() => {
          this.fetchState = FetchState.Uninitialized;
          const notifier = useNotifierStore();
          notifier.setDanger("Unable to load country list.");
        });
    },
    getCountryNameFromCode (countryCode: string) {
      if (this.fetchState !== FetchState.Loaded) {
        return "";
      }

      const country = this.countries.find(country => country.code === countryCode);
      return country ? country.name : "";
    }
  }
});
